import { AutoComplete } from 'antd';
import styled from 'styled-components';
import { GridNine, RectangleDashed } from '@phosphor-icons/react';
import { ColoredPill } from '../../elements';
import {
  LocationSearchHook,
  useAutocompleteInput,
  useAutocompleteLoading,
  useDebounce,
} from '../../hooks';
import { AutocompleteSearchInput } from '../../components';

const OptionContainer = styled.div`
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

function resultRenderer({ search, code, rack, zone, _id }) {
  const showResult = string => {
    try {
      const highlighted = string.replace(
        new RegExp(search, 'gi'),
        d => `<strong>${d}</strong>`,
      );

      return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
    } catch (error) {
      return string;
    }
  };

  return (
    <OptionContainer key={_id}>
      <span>{showResult(code)}</span>
      <div className="d-flex flex-column align-items-end">
        <ColoredPill color={zone.color}>
          <GridNine /> {rack.code}
        </ColoredPill>
        <ColoredPill className="mt-1" color={zone.color}>
          <RectangleDashed /> {zone.code}
        </ColoredPill>
      </div>
    </OptionContainer>
  );
}

export function InventoryLocationSearch({
  top,
  onResultClick,
  inputClassName,
  setTableSearch = () => {},
  warehouseId,
}) {
  const { display, query, onSearch, onSelect, clear } =
    useAutocompleteInput(setTableSearch);

  const finalSearch = useDebounce(query, 400);

  const { data, loading } = LocationSearchHook(warehouseId, finalSearch);
  const isSearching = useAutocompleteLoading(query, finalSearch, loading);

  const optionIds = (data ?? []).map(d => d._id).filter(Boolean);

  const options = (data ?? []).map(item => ({
    value: item._id,
    label: resultRenderer({ ...item, search: display }),
  }));

  return (
    <AutoComplete
      style={{ width: '100%' }}
      className={inputClassName}
      value={display}
      options={options}
      filterOption={false}
      placeholder="Search Location"
      placement={top ? 'topLeft' : 'bottomLeft'}
      classNames={{ popup: { root: 'auto-search-dropdown' } }}
      onSearch={value => onSearch(value, optionIds)}
      onSelect={value => {
        const item = data.find(d => d._id === value);
        if (item) {
          onSelect(item.code || '', () => onResultClick(item));
        }
      }}
    >
      <AutocompleteSearchInput isSearching={isSearching} onClear={clear} />
    </AutoComplete>
  );
}
